const resSuccess = 'Success';
const resError = 'Error';

export {
  resSuccess,
  resError
}